import { Stack, Typography } from "@mui/material";
import aboutConstants from "../../data/about/aboutUs.json";

type Props = {};

const About = (props: Props) => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
        {aboutConstants?.title}
      </Typography>
      <Stack direction="column" spacing={2}>
        {aboutConstants?.description?.map((desc: string, index: number) => (
          <Typography
            sx={{ fontFamily: "inherit" }}
            variant="body2"
            textAlign="justify"
            key={index}
          >
            {desc}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export default About;
